import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { useTranslation } from 'react-i18next';

type Props<T> = { text?: string; value?: T; onClick?: (v?: T) => void };

const SuccessToast = <T,>({ text, value, onClick }: Props<T>) => {
  const { t } = useTranslation('common');
  return (
    <Snackbar open anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} className="tw-invisible lg:tw-visible">
      <Alert variant="filled" severity="success" onClick={() => (onClick ? onClick(value) : undefined)}>
        {text || t('httpSuccess')}
      </Alert>
    </Snackbar>
  );
};

export default SuccessToast;
